import { useEffect, type ReactNode } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { inAppReferrerPath, recordInAppNavigation } from '@/lib/inAppBack';

/** Records each in-app visit so detail pages can offer a back step. */
export function InAppHistoryProvider({ children }: { children: ReactNode }) {
  const location = useLocation();
  const navType = useNavigationType();
  const path = `${location.pathname}${location.search}`;

  useEffect(() => {
    recordInAppNavigation({
      key: location.key,
      path,
      navType,
      referrerPath: inAppReferrerPath(document.referrer, window.location.origin, path),
    });
  }, [location.key, navType, path]);

  return children;
}
